import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  fetching: true,
  libraryPicks: [],
  error: null,
  hasMore: true
}

const libraryPicksSlice = createSlice({
  name: 'libraryPicksReducer',
  initialState,
  reducers: {
    requestLibraryPicks: state => {
      state.fetching = true
    },
    requestLibraryPicksSuccess: (state, { payload }) => {
      state.fetching = false
      state.libraryPicks = payload
    },
    requestLibraryPicksFailed: (state, { payload }) => {
      state.fetching = false
      state.error = payload
    },
    appendLibraryPicks: (state, { payload }) => {
      state.fetching = false
      state.libraryPicks = [...state.libraryPicks, ...payload]
    },
    setHasMore: (state, { payload }) => {
      state.hasMore = payload
    },
    addLibraryPick: (state, _action) => {
      state.fetching = true
    },
    addLibraryPickSuccess: (state, _action) => {
      state.fetching = false
    },
    addLibraryPickFailed: (state, { payload }) => {
      state.fetching = false
      state.error = payload
    },
    removeLibraryPick: (state, _action) => {
      state.fetching = true
    },
    removeLibraryPickSuccess: (state, { payload }) => {
      state.fetching = false
      // Remove the library pick from the state (In Library Picks page)
      const { libraryPickId } = payload
      state.libraryPicks = state.libraryPicks.filter(
        pick => pick.library_pick?.library_pick_id !== libraryPickId
      )
    },
    removeLibraryPickFailed: (state, { payload }) => {
      state.fetching = false
      state.error = payload
    }
  }
})

export const { actions, reducer } = libraryPicksSlice

export const {
  requestLibraryPicks,
  requestLibraryPicksSuccess,
  requestLibraryPicksFailed,
  addLibraryPick,
  addLibraryPickSuccess,
  addLibraryPickFailed,
  appendLibraryPicks,
  removeLibraryPick,
  removeLibraryPickSuccess,
  removeLibraryPickFailed,
  setHasMore
} = actions

export default reducer
